module.exports = __webpack_public_path__ + "img/div-pro.d8310ec9.jpg";